export const localStorageTokenKey = 'jwtToken';
